/**
 * useSelectedHolder — Fias Leads compatibility wrapper over the
 * platform-level `useHolderSwitcher` (`@/components/HolderSwitcher`).
 *
 * Selection is shared with every other arche so switching workspace
 * anywhere is reflected here. This wrapper exposes the legacy shape
 * (`holderId`, `setHolderId`, `principalId`, `personalHolderId`,
 * `orgMemberships`) so existing Fias Leads call sites don't need to
 * change.
 */

import { useHolderSwitcher } from '@/components/HolderSwitcher';
import type { VaultMembershipDto } from '@/lib/api';

export function useSelectedHolder(): {
  holderId: string | null;
  setHolderId: (next: string | null) => void;
  principalId: string | null;
  personalHolderId: string | null;
  orgMemberships: VaultMembershipDto[];
  isLoading: boolean;
  isError: boolean;
} {
  const switcher = useHolderSwitcher();
  return {
    holderId: switcher.selectedHolderId,
    setHolderId: switcher.setSelectedHolderId,
    principalId: switcher.principalId,
    personalHolderId: switcher.personalHolder?.holderId ?? null,
    orgMemberships: switcher.memberships.filter(
      (m): m is VaultMembershipDto => m.status === 'active' && m.holderType === 'org',
    ),
    isLoading: switcher.isLoading,
    isError: switcher.isError,
  };
}
